import axios from '@axios'

export const state = {
  auctions: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allAuctions: (state) => state.auctions,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_AUCTIONS: (state, resp) => {
    if (!resp) return null
    state.auctions = resp.auctions
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_AUCTION: (state, auction) => {
    state.auctions = state.auctions.filter((w) => w.id !== auction.id)
  },
}

export const actions = {
  async getAuctions({ commit }, params = {}) {
    await axios
      .get('/api/auctions', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_AUCTIONS', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_AUCTIONS',
          err.response.status === 404 ? { auctions: [] } : null
        )
      })
  },
  async createAuction({ commit }, auction) {
    return axios.post(`/api/auctions`, auction)
  },
  async editAuction({ commit }, auction) {
    return axios.put(`/api/auctions`, auction)
  },
  async deleteAuction({ commit }, auction) {
    await axios.delete(`/api/auctions/${auction.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_AUCTION', auction)
      }
    })
  },
}
